import clients from '../../../data/clients';

export default {
  slug: 'jlr-electric-vehicle',
  company: clients.jaguar.name,
  logo: clients.jaguar.logo,
  logoWhite: clients.jaguar.logoWhite,
  blurb: {
    headline: "The new electric luxury vehicle.",
    tags: [],
    byline: 'Learn more about our work with Jaguar',
    background: require('./preview.jpg'),
    backgroundSet: [
      {
        max: 1024,
        src: require('./preview-mobile.jpg'),
      },
    ],
  },
  blocks: [
    {
      module: 'hero',
      background: {
        image: require('./hero.jpg'),
        type: 'image',
      },
      constrain: true,
    },
    {
      module: 'intro',
      title: 'A luxury all-electric vehicle.',
      content: 'When Jaguar Land Rover (JLR) decided to make a move into the electric vehicle market with their first all-electric car, they asked the team at Particle Design to help them create an IVI (in-vehicle infotainment) system for their EV that was as exciting, technologically innovative, and future-facing as the car itself promised to be.\n\nJaguar Land Rover knew they were facing a critical challenge. Electric vehicles need to not only solve many of the same problems as regular cars, they also need to design around key infrastructure challenges that early adopters of electric vehicles face.',
      roles: [
        'Future Forecasting Workshop',
        'Ethnographic Interviews',
        'Competitive Landscape',
        'Concept Design',
        'Interaction Design',
        'Visual Design',
        'Prototyping',
        'Front-End Development',
      ],
    },
    {
      module: 'text_image_stack',
      image: {
        src: require('./article/steering-wheel.jpg'),
        alt: 'image of a steering wheel with the digital interface on the dashboard',
      },
      content: '## How do you transform the electric vehicle experience? Reduce range anxiety. \n\n Known as “range anxiety,” electric vehicle (EV) drivers worry that they may not have enough charge to reach their destination or the next charging station. Some electric car makers have sought to ease the problem of range anxiety by building an infrastructure of charging stations to support drivers. But Jaguar Land Rover is a car company with a global reach , and creating a unique infrastructure to support its worldwide presence was untenable. They knew EVs were the transportation of the future, but until the real world caught up with this burgeoning industry, they’d need to design a vehicle that integrated with existing infrastructures and systems.',
    },
    {
      module: 'text_image_row',
      images: [
        {
          src: require('./article/map.jpg'),
          height: '380px',
          gravity: 'center center',
          primary: true,
        },
      ],
      content: "## Pairing existing infrastructure with sharper design. \n\n Particle Design helped Jaguar Land Rover design an IVI system that can intelligently plan and route people to charging stations, not only when en route but also as they plan their trips. The design we created allows for smart, automated, contextual updates to the navigation system. It also includes a mobile app that can deliver alerts and communications about car and battery status when drivers are away from their vehicle.",
    },
    {
      module: 'row',
      columns: [
        {
          grid: {
            start: 3,
            end: 8,
          },
          component: 'markdown',
          content: '## When a concept car is more than a concept. \n\n From idea to marketplace, Particle helped JLR bridge the gap between high concept and on-the-road usability by keeping future forecasting and design grounded in solving problems instead of just catching the eye.',
        },
      ],
    },
    {
      module: 'row',
      columns: [
        {
          grid: {
            start: 2,
            end: 11,
          },
          component: 'blockquote',
          modifier: 'big',
          quote: 'The new Jaguar I-Pace concept has the potential of becoming a breakthrough vehicle, a luxury electric SUV that could cause quite a headache for Tesla Motors.',
          sourceName: 'USA Today, Feb 2016',
        },
      ],
    },
    {
      module: 'row',
      columns: [
        {
          grid: {
            start: 1,
            end: 12,
          },
          component: 'image',
          src: require('./article/taillight.jpg'),
          alt: 'Image of a taillight',
        },
      ],
    },
    {
      module: 'relatedWorks',
      works: [
        'vr-science-education',
        'dreamworks',
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/content/work/land-rover/index.js